import { Spinner } from '@heroui/spinner';
import { Navigate } from '@tanstack/react-router';
import { type ReactNode } from 'react';

import { useAuth } from '../firebase/useAuth.ts';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { currentUser, loading } = useAuth();

  console.log('ProtectedRoute - loading:', loading, 'currentUser:', currentUser?.email ?? 'null');

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <Spinner size="lg" />
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!currentUser) {
    console.log('ProtectedRoute - No user, redirecting to login');
    return <Navigate to="/login" />;
  }

  console.log('ProtectedRoute - User authenticated, showing children');
  return <>{children}</>;
}
